/**
 * 岗位管理接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PositionManagementService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;

   //文件处理微服务api
   filefix: string = environment.fileWebAPI;
 
   //任务调度微服务api
   schedulefix: string = environment.scheduleWebApi;
 
   //任务调度微服务api
   activitiWebAPI: string = environment.activitiWebAPI;
 
   constructor(
     private http: SwHttpClientService,
     private httpClient: HttpClient,
   ) {
   }

  //#region 岗位管理接口
  /**
   * 分页查询岗位
   * @param param
   * @returns {Observable<any>}
   */
  queryPositionPageList(param) {
    const url = this.prefix + 'position/queryPageList';
    return this.http.Post(url, param);
  }

  /**
   * 删除岗位
   * @param param
   * @returns {Observable<any>}
   */
  deletePosition(param) {
    const url = this.prefix + 'position/deleteBatch';
    return this.http.Post(url, param);
  }

  /**
   * 岗位设置
   * @param param
   * @returns {Observable<any>}
   */
  updatePosition(param) {
    const url = this.prefix + 'position/updateById';
    return this.http.Post(url, param);
  }

  /**
   * 修改岗位
   * @param param
   * @returns {Observable<any>}
   */
  editPosition(param) {
    const url = this.prefix + 'position/updatePosition';
    return this.http.Post(url, param);
  }

  /**
   * 新增岗位
   * @param param
   * @returns {Observable<any>}
   */
  savePosition(param) {
    const url = this.prefix + 'position/save';
    return this.http.Post(url, param);
  }

  /**
   * 查询单个岗位信息
   * @param param
   */
  getPosition(param) {
    const url = this.prefix + 'position/queryById';
    return this.http.Post(url, param);
  }

  /**
   * 无管理权限获取岗位列表
   * @param param
   * @returns {Observable<any>}
   */
  queryList(param){
    const url = this.activitiWebAPI + 'position/queryList';
    return this.http.Post(url, param);
  }

  //启用禁用岗位
  updateStatus(param){
    const url = this.prefix + 'position/updateStatus';
    return this.http.Post(url, param);
  }
  
  //#endregion


}
